import { useEffect, useState } from "react";

export default function PageLoader() {
  const [show, setShow] = useState(() => !sessionStorage.getItem("dt-loaded"));
  const [fade, setFade] = useState(false);

  useEffect(() => {
    if (!show) return;
    const done = () => {
      setFade(true);
      sessionStorage.setItem("dt-loaded", "1");
      setTimeout(() => setShow(false), 450);
    };
    if (document.readyState === "complete") {
      const t = setTimeout(done, 900);
      return () => clearTimeout(t);
    }
    const onLoad = () => setTimeout(done, 500);
    window.addEventListener("load", onLoad);
    const fallback = setTimeout(done, 2600);
    return () => { window.removeEventListener("load", onLoad); clearTimeout(fallback); };
  }, [show]);

  if (!show) return null;
  return (
    <div
      className={`fixed inset-0 z-[100] bg-dt-bg flex flex-col items-center justify-center transition-opacity duration-500 ${fade ? "opacity-0 pointer-events-none" : "opacity-100"}`}
      data-testid="page-loader"
      aria-hidden={!show}
    >
      <img src="/assets/logo.png" alt="Destiny Tip" className="loader-logo w-24 h-24 rounded-3xl object-cover" />
      <p className="mt-6 font-heading font-bold tracking-[0.3em] text-sm text-metallic">DESTINY TIP</p>
      <p className="mt-2 text-xs text-dt-muted tracking-widest uppercase">Where every stream finds its destiny</p>
    </div>
  );
}
